export class StorageMirroredIdentity {
    identity;
    storage;
    constructor(identity, storage) {
        this.identity = identity;
        this.storage = storage;
    }
    async generate() {
        const identity = await this.identity.generate();
        await this.storage.refreshIdentityMetadata();
        return identity;
    }
    async sign(keyHandle, payload) {
        return await this.identity.sign(keyHandle, payload);
    }
    async publicIdentity() {
        return await this.identity.publicIdentity();
    }
    async loadDelegation() {
        return await this.identity.loadDelegation();
    }
    async storeDelegation(delegation) {
        await this.identity.storeDelegation(delegation);
        await this.storage.refreshIdentityMetadata();
    }
    async loadConnectionMetadata() {
        return await this.identity.loadConnectionMetadata();
    }
    async storeConnectionMetadata(metadata) {
        await this.identity.storeConnectionMetadata(metadata);
        await this.storage.refreshIdentityMetadata();
    }
    async clearDelegation() {
        await this.identity.clearDelegation();
        await this.storage.refreshIdentityMetadata();
    }
    async clear() {
        await this.identity.clear();
        await this.storage.refreshIdentityMetadata();
    }
    async recoverAfterRevocation() {
        const identity = await this.identity.recoverAfterRevocation();
        await this.storage.refreshIdentityMetadata();
        return identity;
    }
    async diagnostics() {
        return await this.identity.diagnostics();
    }
}
//# sourceMappingURL=storage-mirrored-identity.js.map